"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsApi = exports.SubscriptionsApiFactory = exports.SubscriptionsApiFp = exports.SubscriptionsApiFetchParamCreator = exports.StripeApi = exports.StripeApiFactory = exports.StripeApiFp = exports.StripeApiFetchParamCreator = exports.RootApi = exports.RootApiFactory = exports.RootApiFp = exports.RootApiFetchParamCreator = exports.EntitlementsApi = exports.EntitlementsApiFactory = exports.EntitlementsApiFp = exports.EntitlementsApiFetchParamCreator = exports.CheckoutApi = exports.CheckoutApiFactory = exports.CheckoutApiFp = exports.CheckoutApiFetchParamCreator = exports.OrgUpsertResult = exports.GetCheckoutSummaryResponse = exports.EntitlmentFeatureSource = exports.EntitlementV3 = exports.EntitlementSourceFeatureQuantity = exports.EntitlementOverrideRequest = exports.CreateCheckoutSessionRequest = exports.BulkOrgEntitlementV3OperationResult = exports.AssignOrgEntitlementV3Request = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
var url = require("url");
var portableFetch = require("portable-fetch");
var BASE_PATH = "https://api.portal.flipdish.com/entitlements".replace(/\/+$/, "");
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
var BaseAPI = (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
var RequiredError = (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
var AssignOrgEntitlementV3Request;
(function (AssignOrgEntitlementV3Request) {
    var AssignmentTypeEnum;
    (function (AssignmentTypeEnum) {
        AssignmentTypeEnum[AssignmentTypeEnum["Property"] = 'property'] = "Property";
        AssignmentTypeEnum[AssignmentTypeEnum["KioskDeviceAndProperty"] = 'kiosk-device-and-property'] = "KioskDeviceAndProperty";
    })(AssignmentTypeEnum = AssignOrgEntitlementV3Request.AssignmentTypeEnum || (AssignOrgEntitlementV3Request.AssignmentTypeEnum = {}));
})(AssignOrgEntitlementV3Request || (exports.AssignOrgEntitlementV3Request = AssignOrgEntitlementV3Request = {}));
var BulkOrgEntitlementV3OperationResult;
(function (BulkOrgEntitlementV3OperationResult) {
    var OperationEnum;
    (function (OperationEnum) {
        OperationEnum[OperationEnum["Assign"] = 'assign'] = "Assign";
        OperationEnum[OperationEnum["Unassign"] = 'unassign'] = "Unassign";
    })(OperationEnum = BulkOrgEntitlementV3OperationResult.OperationEnum || (BulkOrgEntitlementV3OperationResult.OperationEnum = {}));
    var OutcomeEnum;
    (function (OutcomeEnum) {
        OutcomeEnum[OutcomeEnum["Assigned"] = 'assigned'] = "Assigned";
        OutcomeEnum[OutcomeEnum["Unassigned"] = 'unassigned'] = "Unassigned";
        OutcomeEnum[OutcomeEnum["EntitlementNotFound"] = 'entitlementNotFound'] = "EntitlementNotFound";
        OutcomeEnum[OutcomeEnum["StaleVersion"] = 'staleVersion'] = "StaleVersion";
        OutcomeEnum[OutcomeEnum["TypeNotAllowedForFeature"] = 'typeNotAllowedForFeature'] = "TypeNotAllowedForFeature";
        OutcomeEnum[OutcomeEnum["Error"] = 'error'] = "Error";
    })(OutcomeEnum = BulkOrgEntitlementV3OperationResult.OutcomeEnum || (BulkOrgEntitlementV3OperationResult.OutcomeEnum = {}));
})(BulkOrgEntitlementV3OperationResult || (exports.BulkOrgEntitlementV3OperationResult = BulkOrgEntitlementV3OperationResult = {}));
var CreateCheckoutSessionRequest;
(function (CreateCheckoutSessionRequest) {
    var CountryCodeEnum;
    (function (CountryCodeEnum) {
        CountryCodeEnum[CountryCodeEnum["De"] = 'de'] = "De";
        CountryCodeEnum[CountryCodeEnum["Gb"] = 'gb'] = "Gb";
        CountryCodeEnum[CountryCodeEnum["Ie"] = 'ie'] = "Ie";
        CountryCodeEnum[CountryCodeEnum["Us"] = 'us'] = "Us";
        CountryCodeEnum[CountryCodeEnum["Mx"] = 'mx'] = "Mx";
        CountryCodeEnum[CountryCodeEnum["Es"] = 'es'] = "Es";
        CountryCodeEnum[CountryCodeEnum["Fr"] = 'fr'] = "Fr";
        CountryCodeEnum[CountryCodeEnum["It"] = 'it'] = "It";
        CountryCodeEnum[CountryCodeEnum["Nl"] = 'nl'] = "Nl";
        CountryCodeEnum[CountryCodeEnum["Pt"] = 'pt'] = "Pt";
    })(CountryCodeEnum = CreateCheckoutSessionRequest.CountryCodeEnum || (CreateCheckoutSessionRequest.CountryCodeEnum = {}));
})(CreateCheckoutSessionRequest || (exports.CreateCheckoutSessionRequest = CreateCheckoutSessionRequest = {}));
var EntitlementOverrideRequest;
(function (EntitlementOverrideRequest) {
    var ReasonCodeEnum;
    (function (ReasonCodeEnum) {
        ReasonCodeEnum[ReasonCodeEnum["Legacy"] = 'legacy'] = "Legacy";
        ReasonCodeEnum[ReasonCodeEnum["Temporary"] = 'temporary'] = "Temporary";
    })(ReasonCodeEnum = EntitlementOverrideRequest.ReasonCodeEnum || (EntitlementOverrideRequest.ReasonCodeEnum = {}));
})(EntitlementOverrideRequest || (exports.EntitlementOverrideRequest = EntitlementOverrideRequest = {}));
var EntitlementSourceFeatureQuantity;
(function (EntitlementSourceFeatureQuantity) {
    var SourceTypeEnum;
    (function (SourceTypeEnum) {
        SourceTypeEnum[SourceTypeEnum["Subscription"] = 'subscription'] = "Subscription";
        SourceTypeEnum[SourceTypeEnum["Override"] = 'override'] = "Override";
    })(SourceTypeEnum = EntitlementSourceFeatureQuantity.SourceTypeEnum || (EntitlementSourceFeatureQuantity.SourceTypeEnum = {}));
})(EntitlementSourceFeatureQuantity || (exports.EntitlementSourceFeatureQuantity = EntitlementSourceFeatureQuantity = {}));
var EntitlementV3;
(function (EntitlementV3) {
    var SourceTypeEnum;
    (function (SourceTypeEnum) {
        SourceTypeEnum[SourceTypeEnum["Subscription"] = 'subscription'] = "Subscription";
        SourceTypeEnum[SourceTypeEnum["Override"] = 'override'] = "Override";
    })(SourceTypeEnum = EntitlementV3.SourceTypeEnum || (EntitlementV3.SourceTypeEnum = {}));
})(EntitlementV3 || (exports.EntitlementV3 = EntitlementV3 = {}));
var EntitlmentFeatureSource;
(function (EntitlmentFeatureSource) {
    var SourceTypeEnum;
    (function (SourceTypeEnum) {
        SourceTypeEnum[SourceTypeEnum["Subscription"] = 'subscription'] = "Subscription";
        SourceTypeEnum[SourceTypeEnum["Override"] = 'override'] = "Override";
    })(SourceTypeEnum = EntitlmentFeatureSource.SourceTypeEnum || (EntitlmentFeatureSource.SourceTypeEnum = {}));
})(EntitlmentFeatureSource || (exports.EntitlmentFeatureSource = EntitlmentFeatureSource = {}));
var GetCheckoutSummaryResponse;
(function (GetCheckoutSummaryResponse) {
    var IntervalEnum;
    (function (IntervalEnum) {
        IntervalEnum[IntervalEnum["Day"] = 'day'] = "Day";
        IntervalEnum[IntervalEnum["Month"] = 'month'] = "Month";
        IntervalEnum[IntervalEnum["Week"] = 'week'] = "Week";
        IntervalEnum[IntervalEnum["Year"] = 'year'] = "Year";
    })(IntervalEnum = GetCheckoutSummaryResponse.IntervalEnum || (GetCheckoutSummaryResponse.IntervalEnum = {}));
})(GetCheckoutSummaryResponse || (exports.GetCheckoutSummaryResponse = GetCheckoutSummaryResponse = {}));
var OrgUpsertResult;
(function (OrgUpsertResult) {
    var OutcomeEnum;
    (function (OutcomeEnum) {
        OutcomeEnum[OutcomeEnum["Created"] = 'created'] = "Created";
        OutcomeEnum[OutcomeEnum["Refreshed"] = 'refreshed'] = "Refreshed";
    })(OutcomeEnum = OrgUpsertResult.OutcomeEnum || (OrgUpsertResult.OutcomeEnum = {}));
})(OrgUpsertResult || (exports.OrgUpsertResult = OrgUpsertResult = {}));
var CheckoutApiFetchParamCreator = function (configuration) {
    return {
        createCheckoutSession: function (CreateCheckoutSessionRequest, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/checkout-session";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateCheckoutSessionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateCheckoutSessionRequest || {}) : (CreateCheckoutSessionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createCheckoutSessionForApp: function (appId, CreateCheckoutSessionRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createCheckoutSessionForApp.');
            }
            var localVarPath = "/{appId}/subscriptions/checkout-session"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateCheckoutSessionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateCheckoutSessionRequest || {}) : (CreateCheckoutSessionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createCheckoutSessionForOrg: function (orgId, appId, CreateCheckoutSessionRequest, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling createCheckoutSessionForOrg.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createCheckoutSessionForOrg.');
            }
            var localVarPath = "/org/{orgId}/app/{appId}/subscriptions/checkout-session"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateCheckoutSessionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateCheckoutSessionRequest || {}) : (CreateCheckoutSessionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCheckoutSession: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId', 'Required parameter sessionId was null or undefined when calling getCheckoutSession.');
            }
            var localVarPath = "/checkout-session/{sessionId}"
                .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCheckoutSummary: function (appId, subscriptionId, priceId, addOns, promoCode, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCheckoutSummary.');
            }
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling getCheckoutSummary.');
            }
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId', 'Required parameter priceId was null or undefined when calling getCheckoutSummary.');
            }
            var localVarPath = "/{appId}/subscriptions/{subscriptionId}/checkout-summary"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("subscriptionId", "}"), encodeURIComponent(String(subscriptionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (priceId !== undefined) {
                localVarQueryParameter['priceId'] = priceId;
            }
            if (addOns !== undefined) {
                localVarQueryParameter['addOns'] = addOns;
            }
            if (promoCode !== undefined) {
                localVarQueryParameter['promoCode'] = promoCode;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CheckoutApiFetchParamCreator = CheckoutApiFetchParamCreator;
var CheckoutApiFp = function (configuration) {
    return {
        createCheckoutSession: function (CreateCheckoutSessionRequest, options) {
            var localVarFetchArgs = (0, exports.CheckoutApiFetchParamCreator)(configuration).createCheckoutSession(CreateCheckoutSessionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createCheckoutSessionForApp: function (appId, CreateCheckoutSessionRequest, options) {
            var localVarFetchArgs = (0, exports.CheckoutApiFetchParamCreator)(configuration).createCheckoutSessionForApp(appId, CreateCheckoutSessionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createCheckoutSessionForOrg: function (orgId, appId, CreateCheckoutSessionRequest, options) {
            var localVarFetchArgs = (0, exports.CheckoutApiFetchParamCreator)(configuration).createCheckoutSessionForOrg(orgId, appId, CreateCheckoutSessionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCheckoutSession: function (sessionId, options) {
            var localVarFetchArgs = (0, exports.CheckoutApiFetchParamCreator)(configuration).getCheckoutSession(sessionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCheckoutSummary: function (appId, subscriptionId, priceId, addOns, promoCode, options) {
            var localVarFetchArgs = (0, exports.CheckoutApiFetchParamCreator)(configuration).getCheckoutSummary(appId, subscriptionId, priceId, addOns, promoCode, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CheckoutApiFp = CheckoutApiFp;
var CheckoutApiFactory = function (configuration, fetch, basePath) {
    return {
        createCheckoutSession: function (CreateCheckoutSessionRequest, options) {
            return (0, exports.CheckoutApiFp)(configuration).createCheckoutSession(CreateCheckoutSessionRequest, options)(fetch, basePath);
        },
        createCheckoutSessionForApp: function (appId, CreateCheckoutSessionRequest, options) {
            return (0, exports.CheckoutApiFp)(configuration).createCheckoutSessionForApp(appId, CreateCheckoutSessionRequest, options)(fetch, basePath);
        },
        createCheckoutSessionForOrg: function (orgId, appId, CreateCheckoutSessionRequest, options) {
            return (0, exports.CheckoutApiFp)(configuration).createCheckoutSessionForOrg(orgId, appId, CreateCheckoutSessionRequest, options)(fetch, basePath);
        },
        getCheckoutSession: function (sessionId, options) {
            return (0, exports.CheckoutApiFp)(configuration).getCheckoutSession(sessionId, options)(fetch, basePath);
        },
        getCheckoutSummary: function (appId, subscriptionId, priceId, addOns, promoCode, options) {
            return (0, exports.CheckoutApiFp)(configuration).getCheckoutSummary(appId, subscriptionId, priceId, addOns, promoCode, options)(fetch, basePath);
        },
    };
};
exports.CheckoutApiFactory = CheckoutApiFactory;
var CheckoutApi = (function (_super) {
    __extends(CheckoutApi, _super);
    function CheckoutApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutApi.prototype.createCheckoutSession = function (CreateCheckoutSessionRequest, options) {
        return (0, exports.CheckoutApiFp)(this.configuration).createCheckoutSession(CreateCheckoutSessionRequest, options)(this.fetch, this.basePath);
    };
    CheckoutApi.prototype.createCheckoutSessionForApp = function (appId, CreateCheckoutSessionRequest, options) {
        return (0, exports.CheckoutApiFp)(this.configuration).createCheckoutSessionForApp(appId, CreateCheckoutSessionRequest, options)(this.fetch, this.basePath);
    };
    CheckoutApi.prototype.createCheckoutSessionForOrg = function (orgId, appId, CreateCheckoutSessionRequest, options) {
        return (0, exports.CheckoutApiFp)(this.configuration).createCheckoutSessionForOrg(orgId, appId, CreateCheckoutSessionRequest, options)(this.fetch, this.basePath);
    };
    CheckoutApi.prototype.getCheckoutSession = function (sessionId, options) {
        return (0, exports.CheckoutApiFp)(this.configuration).getCheckoutSession(sessionId, options)(this.fetch, this.basePath);
    };
    CheckoutApi.prototype.getCheckoutSummary = function (appId, subscriptionId, priceId, addOns, promoCode, options) {
        return (0, exports.CheckoutApiFp)(this.configuration).getCheckoutSummary(appId, subscriptionId, priceId, addOns, promoCode, options)(this.fetch, this.basePath);
    };
    return CheckoutApi;
}(BaseAPI));
exports.CheckoutApi = CheckoutApi;
var EntitlementsApiFetchParamCreator = function (configuration) {
    return {
        assignOrgEntitlementV3: function (orgId, entitlementId, AssignOrgEntitlementV3Request, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling assignOrgEntitlementV3.');
            }
            if (entitlementId === null || entitlementId === undefined) {
                throw new RequiredError('entitlementId', 'Required parameter entitlementId was null or undefined when calling assignOrgEntitlementV3.');
            }
            var localVarPath = "/org/{orgId}/entitlements-v3/{entitlementId}/assign"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("entitlementId", "}"), encodeURIComponent(String(entitlementId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AssignOrgEntitlementV3Request" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(AssignOrgEntitlementV3Request || {}) : (AssignOrgEntitlementV3Request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        bulkOrgEntitlementAssignmentsV3: function (orgId, BulkOrgEntitlementV3AssignmentsRequest, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling bulkOrgEntitlementAssignmentsV3.');
            }
            var localVarPath = "/org/{orgId}/entitlements-v3/assignments/bulk"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BulkOrgEntitlementV3AssignmentsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BulkOrgEntitlementV3AssignmentsRequest || {}) : (BulkOrgEntitlementV3AssignmentsRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        bulkUpsertOrgs: function (BulkUpsertOrgsRequest, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/orgs/bulk";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BulkUpsertOrgsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BulkUpsertOrgsRequest || {}) : (BulkUpsertOrgsRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAppEntitlements: function (appId, expand, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppEntitlements.');
            }
            var localVarPath = "/{appId}/entitlements"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrgEntitlementV3: function (orgId, entitlementId, featureCode, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getOrgEntitlementV3.');
            }
            if (entitlementId === null || entitlementId === undefined) {
                throw new RequiredError('entitlementId', 'Required parameter entitlementId was null or undefined when calling getOrgEntitlementV3.');
            }
            if (featureCode === null || featureCode === undefined) {
                throw new RequiredError('featureCode', 'Required parameter featureCode was null or undefined when calling getOrgEntitlementV3.');
            }
            var localVarPath = "/org/{orgId}/entitlements-v3/{entitlementId}"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("entitlementId", "}"), encodeURIComponent(String(entitlementId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (featureCode !== undefined) {
                localVarQueryParameter['featureCode'] = featureCode;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrganisationEntitlements: function (orgId, expand, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getOrganisationEntitlements.');
            }
            var localVarPath = "/org/{orgId}/entitlements"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrganisationEntitlementsV2: function (orgId, expand, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getOrganisationEntitlementsV2.');
            }
            var localVarPath = "/org/{orgId}/entitlements-v2"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        listOrgEntitlementSources: function (orgId, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling listOrgEntitlementSources.');
            }
            var localVarPath = "/org/{orgId}/entitlement-sources"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        listOrgEntitlementsV3: function (orgId, featureCode, assignmentType, target, targetId, sourceType, sourceRef, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling listOrgEntitlementsV3.');
            }
            var localVarPath = "/org/{orgId}/entitlements-v3"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (featureCode !== undefined) {
                localVarQueryParameter['featureCode'] = featureCode;
            }
            if (assignmentType !== undefined) {
                localVarQueryParameter['assignmentType'] = assignmentType;
            }
            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }
            if (sourceType !== undefined) {
                localVarQueryParameter['sourceType'] = sourceType;
            }
            if (sourceRef !== undefined) {
                localVarQueryParameter['sourceRef'] = sourceRef;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unassignOrgEntitlementV3: function (orgId, entitlementId, UnassignOrgEntitlementV3Request, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling unassignOrgEntitlementV3.');
            }
            if (entitlementId === null || entitlementId === undefined) {
                throw new RequiredError('entitlementId', 'Required parameter entitlementId was null or undefined when calling unassignOrgEntitlementV3.');
            }
            var localVarPath = "/org/{orgId}/entitlements-v3/{entitlementId}/unassign"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("entitlementId", "}"), encodeURIComponent(String(entitlementId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UnassignOrgEntitlementV3Request" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UnassignOrgEntitlementV3Request || {}) : (UnassignOrgEntitlementV3Request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        upsertAppEntitlementOverrides: function (orgId, EntitlementOverrideRequest, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling upsertAppEntitlementOverrides.');
            }
            var localVarPath = "/org/{orgId}/overrides/entitlements"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("EntitlementOverrideRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(EntitlementOverrideRequest || {}) : (EntitlementOverrideRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.EntitlementsApiFetchParamCreator = EntitlementsApiFetchParamCreator;
var EntitlementsApiFp = function (configuration) {
    return {
        assignOrgEntitlementV3: function (orgId, entitlementId, AssignOrgEntitlementV3Request, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).assignOrgEntitlementV3(orgId, entitlementId, AssignOrgEntitlementV3Request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        bulkOrgEntitlementAssignmentsV3: function (orgId, BulkOrgEntitlementV3AssignmentsRequest, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).bulkOrgEntitlementAssignmentsV3(orgId, BulkOrgEntitlementV3AssignmentsRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        bulkUpsertOrgs: function (BulkUpsertOrgsRequest, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).bulkUpsertOrgs(BulkUpsertOrgsRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAppEntitlements: function (appId, expand, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).getAppEntitlements(appId, expand, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrgEntitlementV3: function (orgId, entitlementId, featureCode, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).getOrgEntitlementV3(orgId, entitlementId, featureCode, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrganisationEntitlements: function (orgId, expand, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).getOrganisationEntitlements(orgId, expand, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrganisationEntitlementsV2: function (orgId, expand, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).getOrganisationEntitlementsV2(orgId, expand, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        listOrgEntitlementSources: function (orgId, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).listOrgEntitlementSources(orgId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        listOrgEntitlementsV3: function (orgId, featureCode, assignmentType, target, targetId, sourceType, sourceRef, page, pageSize, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).listOrgEntitlementsV3(orgId, featureCode, assignmentType, target, targetId, sourceType, sourceRef, page, pageSize, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unassignOrgEntitlementV3: function (orgId, entitlementId, UnassignOrgEntitlementV3Request, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).unassignOrgEntitlementV3(orgId, entitlementId, UnassignOrgEntitlementV3Request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        upsertAppEntitlementOverrides: function (orgId, EntitlementOverrideRequest, options) {
            var localVarFetchArgs = (0, exports.EntitlementsApiFetchParamCreator)(configuration).upsertAppEntitlementOverrides(orgId, EntitlementOverrideRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.EntitlementsApiFp = EntitlementsApiFp;
var EntitlementsApiFactory = function (configuration, fetch, basePath) {
    return {
        assignOrgEntitlementV3: function (orgId, entitlementId, AssignOrgEntitlementV3Request, options) {
            return (0, exports.EntitlementsApiFp)(configuration).assignOrgEntitlementV3(orgId, entitlementId, AssignOrgEntitlementV3Request, options)(fetch, basePath);
        },
        bulkOrgEntitlementAssignmentsV3: function (orgId, BulkOrgEntitlementV3AssignmentsRequest, options) {
            return (0, exports.EntitlementsApiFp)(configuration).bulkOrgEntitlementAssignmentsV3(orgId, BulkOrgEntitlementV3AssignmentsRequest, options)(fetch, basePath);
        },
        bulkUpsertOrgs: function (BulkUpsertOrgsRequest, options) {
            return (0, exports.EntitlementsApiFp)(configuration).bulkUpsertOrgs(BulkUpsertOrgsRequest, options)(fetch, basePath);
        },
        getAppEntitlements: function (appId, expand, options) {
            return (0, exports.EntitlementsApiFp)(configuration).getAppEntitlements(appId, expand, options)(fetch, basePath);
        },
        getOrgEntitlementV3: function (orgId, entitlementId, featureCode, options) {
            return (0, exports.EntitlementsApiFp)(configuration).getOrgEntitlementV3(orgId, entitlementId, featureCode, options)(fetch, basePath);
        },
        getOrganisationEntitlements: function (orgId, expand, options) {
            return (0, exports.EntitlementsApiFp)(configuration).getOrganisationEntitlements(orgId, expand, options)(fetch, basePath);
        },
        getOrganisationEntitlementsV2: function (orgId, expand, options) {
            return (0, exports.EntitlementsApiFp)(configuration).getOrganisationEntitlementsV2(orgId, expand, options)(fetch, basePath);
        },
        listOrgEntitlementSources: function (orgId, options) {
            return (0, exports.EntitlementsApiFp)(configuration).listOrgEntitlementSources(orgId, options)(fetch, basePath);
        },
        listOrgEntitlementsV3: function (orgId, featureCode, assignmentType, target, targetId, sourceType, sourceRef, page, pageSize, options) {
            return (0, exports.EntitlementsApiFp)(configuration).listOrgEntitlementsV3(orgId, featureCode, assignmentType, target, targetId, sourceType, sourceRef, page, pageSize, options)(fetch, basePath);
        },
        unassignOrgEntitlementV3: function (orgId, entitlementId, UnassignOrgEntitlementV3Request, options) {
            return (0, exports.EntitlementsApiFp)(configuration).unassignOrgEntitlementV3(orgId, entitlementId, UnassignOrgEntitlementV3Request, options)(fetch, basePath);
        },
        upsertAppEntitlementOverrides: function (orgId, EntitlementOverrideRequest, options) {
            return (0, exports.EntitlementsApiFp)(configuration).upsertAppEntitlementOverrides(orgId, EntitlementOverrideRequest, options)(fetch, basePath);
        },
    };
};
exports.EntitlementsApiFactory = EntitlementsApiFactory;
var EntitlementsApi = (function (_super) {
    __extends(EntitlementsApi, _super);
    function EntitlementsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EntitlementsApi.prototype.assignOrgEntitlementV3 = function (orgId, entitlementId, AssignOrgEntitlementV3Request, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).assignOrgEntitlementV3(orgId, entitlementId, AssignOrgEntitlementV3Request, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.bulkOrgEntitlementAssignmentsV3 = function (orgId, BulkOrgEntitlementV3AssignmentsRequest, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).bulkOrgEntitlementAssignmentsV3(orgId, BulkOrgEntitlementV3AssignmentsRequest, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.bulkUpsertOrgs = function (BulkUpsertOrgsRequest, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).bulkUpsertOrgs(BulkUpsertOrgsRequest, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.getAppEntitlements = function (appId, expand, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).getAppEntitlements(appId, expand, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.getOrgEntitlementV3 = function (orgId, entitlementId, featureCode, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).getOrgEntitlementV3(orgId, entitlementId, featureCode, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.getOrganisationEntitlements = function (orgId, expand, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).getOrganisationEntitlements(orgId, expand, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.getOrganisationEntitlementsV2 = function (orgId, expand, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).getOrganisationEntitlementsV2(orgId, expand, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.listOrgEntitlementSources = function (orgId, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).listOrgEntitlementSources(orgId, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.listOrgEntitlementsV3 = function (orgId, featureCode, assignmentType, target, targetId, sourceType, sourceRef, page, pageSize, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).listOrgEntitlementsV3(orgId, featureCode, assignmentType, target, targetId, sourceType, sourceRef, page, pageSize, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.unassignOrgEntitlementV3 = function (orgId, entitlementId, UnassignOrgEntitlementV3Request, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).unassignOrgEntitlementV3(orgId, entitlementId, UnassignOrgEntitlementV3Request, options)(this.fetch, this.basePath);
    };
    EntitlementsApi.prototype.upsertAppEntitlementOverrides = function (orgId, EntitlementOverrideRequest, options) {
        return (0, exports.EntitlementsApiFp)(this.configuration).upsertAppEntitlementOverrides(orgId, EntitlementOverrideRequest, options)(this.fetch, this.basePath);
    };
    return EntitlementsApi;
}(BaseAPI));
exports.EntitlementsApi = EntitlementsApi;
var RootApiFetchParamCreator = function (configuration) {
    return {
        healthCheck: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/health";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        root: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.RootApiFetchParamCreator = RootApiFetchParamCreator;
var RootApiFp = function (configuration) {
    return {
        healthCheck: function (options) {
            var localVarFetchArgs = (0, exports.RootApiFetchParamCreator)(configuration).healthCheck(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        root: function (options) {
            var localVarFetchArgs = (0, exports.RootApiFetchParamCreator)(configuration).root(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.RootApiFp = RootApiFp;
var RootApiFactory = function (configuration, fetch, basePath) {
    return {
        healthCheck: function (options) {
            return (0, exports.RootApiFp)(configuration).healthCheck(options)(fetch, basePath);
        },
        root: function (options) {
            return (0, exports.RootApiFp)(configuration).root(options)(fetch, basePath);
        },
    };
};
exports.RootApiFactory = RootApiFactory;
var RootApi = (function (_super) {
    __extends(RootApi, _super);
    function RootApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RootApi.prototype.healthCheck = function (options) {
        return (0, exports.RootApiFp)(this.configuration).healthCheck(options)(this.fetch, this.basePath);
    };
    RootApi.prototype.root = function (options) {
        return (0, exports.RootApiFp)(this.configuration).root(options)(this.fetch, this.basePath);
    };
    return RootApi;
}(BaseAPI));
exports.RootApi = RootApi;
var StripeApiFetchParamCreator = function (configuration) {
    return {
        republishOrgEntitlements: function (UNKNOWN_BASE_TYPE, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/sync/republish-org-entitlements";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UNKNOWN_BASE_TYPE || {}) : (UNKNOWN_BASE_TYPE || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        syncInvoice: function (SyncInvoiceRequest, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/sync/invoice";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SyncInvoiceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SyncInvoiceRequest || {}) : (SyncInvoiceRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        syncProducts: function (SyncProductsRequest, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/sync/products";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SyncProductsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SyncProductsRequest || {}) : (SyncProductsRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        syncSubscriptions: function (SyncSubscriptionsRequest, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/sync/subscriptions";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SyncSubscriptionsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SyncSubscriptionsRequest || {}) : (SyncSubscriptionsRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StripeApiFetchParamCreator = StripeApiFetchParamCreator;
var StripeApiFp = function (configuration) {
    return {
        republishOrgEntitlements: function (UNKNOWN_BASE_TYPE, options) {
            var localVarFetchArgs = (0, exports.StripeApiFetchParamCreator)(configuration).republishOrgEntitlements(UNKNOWN_BASE_TYPE, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        syncInvoice: function (SyncInvoiceRequest, options) {
            var localVarFetchArgs = (0, exports.StripeApiFetchParamCreator)(configuration).syncInvoice(SyncInvoiceRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        syncProducts: function (SyncProductsRequest, options) {
            var localVarFetchArgs = (0, exports.StripeApiFetchParamCreator)(configuration).syncProducts(SyncProductsRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        syncSubscriptions: function (SyncSubscriptionsRequest, options) {
            var localVarFetchArgs = (0, exports.StripeApiFetchParamCreator)(configuration).syncSubscriptions(SyncSubscriptionsRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.StripeApiFp = StripeApiFp;
var StripeApiFactory = function (configuration, fetch, basePath) {
    return {
        republishOrgEntitlements: function (UNKNOWN_BASE_TYPE, options) {
            return (0, exports.StripeApiFp)(configuration).republishOrgEntitlements(UNKNOWN_BASE_TYPE, options)(fetch, basePath);
        },
        syncInvoice: function (SyncInvoiceRequest, options) {
            return (0, exports.StripeApiFp)(configuration).syncInvoice(SyncInvoiceRequest, options)(fetch, basePath);
        },
        syncProducts: function (SyncProductsRequest, options) {
            return (0, exports.StripeApiFp)(configuration).syncProducts(SyncProductsRequest, options)(fetch, basePath);
        },
        syncSubscriptions: function (SyncSubscriptionsRequest, options) {
            return (0, exports.StripeApiFp)(configuration).syncSubscriptions(SyncSubscriptionsRequest, options)(fetch, basePath);
        },
    };
};
exports.StripeApiFactory = StripeApiFactory;
var StripeApi = (function (_super) {
    __extends(StripeApi, _super);
    function StripeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripeApi.prototype.republishOrgEntitlements = function (UNKNOWN_BASE_TYPE, options) {
        return (0, exports.StripeApiFp)(this.configuration).republishOrgEntitlements(UNKNOWN_BASE_TYPE, options)(this.fetch, this.basePath);
    };
    StripeApi.prototype.syncInvoice = function (SyncInvoiceRequest, options) {
        return (0, exports.StripeApiFp)(this.configuration).syncInvoice(SyncInvoiceRequest, options)(this.fetch, this.basePath);
    };
    StripeApi.prototype.syncProducts = function (SyncProductsRequest, options) {
        return (0, exports.StripeApiFp)(this.configuration).syncProducts(SyncProductsRequest, options)(this.fetch, this.basePath);
    };
    StripeApi.prototype.syncSubscriptions = function (SyncSubscriptionsRequest, options) {
        return (0, exports.StripeApiFp)(this.configuration).syncSubscriptions(SyncSubscriptionsRequest, options)(this.fetch, this.basePath);
    };
    return StripeApi;
}(BaseAPI));
exports.StripeApi = StripeApi;
var SubscriptionsApiFetchParamCreator = function (configuration) {
    return {
        checkoutUpdateSubscription: function (appId, subscriptionId, CheckoutUpdateSubscriptionRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling checkoutUpdateSubscription.');
            }
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling checkoutUpdateSubscription.');
            }
            var localVarPath = "/{appId}/subscriptions/{subscriptionId}/checkout-subscription-update"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("subscriptionId", "}"), encodeURIComponent(String(subscriptionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CheckoutUpdateSubscriptionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CheckoutUpdateSubscriptionRequest || {}) : (CheckoutUpdateSubscriptionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrgSubscriptions: function (orgId, excludeCancelledSubscriptions, excludeNotOwnedSubscriptions, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getOrgSubscriptions.');
            }
            var localVarPath = "/org/{orgId}/subscriptions"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (excludeCancelledSubscriptions !== undefined) {
                localVarQueryParameter['excludeCancelledSubscriptions'] = excludeCancelledSubscriptions;
            }
            if (excludeNotOwnedSubscriptions !== undefined) {
                localVarQueryParameter['excludeNotOwnedSubscriptions'] = excludeNotOwnedSubscriptions;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSubscriptionWithInvoice: function (orgId, subscriptionId, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getSubscriptionWithInvoice.');
            }
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling getSubscriptionWithInvoice.');
            }
            var localVarPath = "/org/{orgId}/subscriptions/{subscriptionId}"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("subscriptionId", "}"), encodeURIComponent(String(subscriptionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SubscriptionsApiFetchParamCreator = SubscriptionsApiFetchParamCreator;
var SubscriptionsApiFp = function (configuration) {
    return {
        checkoutUpdateSubscription: function (appId, subscriptionId, CheckoutUpdateSubscriptionRequest, options) {
            var localVarFetchArgs = (0, exports.SubscriptionsApiFetchParamCreator)(configuration).checkoutUpdateSubscription(appId, subscriptionId, CheckoutUpdateSubscriptionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrgSubscriptions: function (orgId, excludeCancelledSubscriptions, excludeNotOwnedSubscriptions, options) {
            var localVarFetchArgs = (0, exports.SubscriptionsApiFetchParamCreator)(configuration).getOrgSubscriptions(orgId, excludeCancelledSubscriptions, excludeNotOwnedSubscriptions, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getSubscriptionWithInvoice: function (orgId, subscriptionId, options) {
            var localVarFetchArgs = (0, exports.SubscriptionsApiFetchParamCreator)(configuration).getSubscriptionWithInvoice(orgId, subscriptionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.SubscriptionsApiFp = SubscriptionsApiFp;
var SubscriptionsApiFactory = function (configuration, fetch, basePath) {
    return {
        checkoutUpdateSubscription: function (appId, subscriptionId, CheckoutUpdateSubscriptionRequest, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).checkoutUpdateSubscription(appId, subscriptionId, CheckoutUpdateSubscriptionRequest, options)(fetch, basePath);
        },
        getOrgSubscriptions: function (orgId, excludeCancelledSubscriptions, excludeNotOwnedSubscriptions, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).getOrgSubscriptions(orgId, excludeCancelledSubscriptions, excludeNotOwnedSubscriptions, options)(fetch, basePath);
        },
        getSubscriptionWithInvoice: function (orgId, subscriptionId, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).getSubscriptionWithInvoice(orgId, subscriptionId, options)(fetch, basePath);
        },
    };
};
exports.SubscriptionsApiFactory = SubscriptionsApiFactory;
var SubscriptionsApi = (function (_super) {
    __extends(SubscriptionsApi, _super);
    function SubscriptionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriptionsApi.prototype.checkoutUpdateSubscription = function (appId, subscriptionId, CheckoutUpdateSubscriptionRequest, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).checkoutUpdateSubscription(appId, subscriptionId, CheckoutUpdateSubscriptionRequest, options)(this.fetch, this.basePath);
    };
    SubscriptionsApi.prototype.getOrgSubscriptions = function (orgId, excludeCancelledSubscriptions, excludeNotOwnedSubscriptions, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).getOrgSubscriptions(orgId, excludeCancelledSubscriptions, excludeNotOwnedSubscriptions, options)(this.fetch, this.basePath);
    };
    SubscriptionsApi.prototype.getSubscriptionWithInvoice = function (orgId, subscriptionId, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).getSubscriptionWithInvoice(orgId, subscriptionId, options)(this.fetch, this.basePath);
    };
    return SubscriptionsApi;
}(BaseAPI));
exports.SubscriptionsApi = SubscriptionsApi;
//# sourceMappingURL=api.js.map